import { render } from "./SupplierCategoryRelationDialog.vue?vue&type=template&id=182bbafa&scoped=true"
import script from "./SupplierCategoryRelationDialog.vue?vue&type=script&lang=js"
export * from "./SupplierCategoryRelationDialog.vue?vue&type=script&lang=js"

import "./SupplierCategoryRelationDialog.vue?vue&type=style&index=0&id=182bbafa&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182bbafa"]])

export default __exports__